var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/company-notice-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-55b328e6!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/company-notice-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyNoticeList.vue
// module id = 595
// module chunks = 1